/* unplugin-vue-components disabled */import { render } from "./w-image.vue?vue&type=template&id=da5faf2e&ts=true"
import script from "./w-image.vue?vue&type=script&lang=ts"
export * from "./w-image.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__